import PreviewBestPrice from "../Previews/PreviewBestPrice/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";

export const BestPriceguarantee = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipBannerPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [ {
        title: "English Title",
        key: "title",
        className: "col-lg-3",
        type: "html",
      },
      {
        title: "Simplified Chinese Title",
        key: "simplified_chinese_title",
        className: "col-lg-3",
        type: "html",
      },
      {
        title: "Traditional Chinese Title",
        key: "traditional_chinese_title",
        className: "col-lg-3",
        type: "html",
      },
      {
        title: "Bahasa Title",
        key: "bahasa_title",
        className: "col-lg-3",
        type: "html",
      },
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

],
      
      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "English Answer",
          key: "answer",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Simplified Chinese Answer",
          key: "simplified_chinese_answer",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Traditional Chinese Answer",
          key: "traditional_chinese_answer",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Bahasa Answer",
          key: "bahasa_answer",
          className: "col-lg-3",
          type: "html",
        },
      ],
      preview: (activetab, cardData) => (
        <PreviewBestPrice activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
